// extracted by mini-css-extract-plugin
export default {"form":"Support_form__gHmCg"};